import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    BookingType,
    CurrencyUnitTotalType,
    PriceInBookingType,
    PriceItemType,
    DifferenceType,
    ActionInBookingType, WhenLastUpdated
} from '@afidium/ts-facade';
import { wenji } from "libraries/interfaces/IWenji";
import { ERateType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { PricesTableService } from "../../services/prices-table.service";
import { Yii } from "libraries/interfaces/Yii";
import { PriceEnvelopeInBookingType } from "@afidium/ts-facade/model/priceEnvelopeInBookingType";
import { PriceTotalsContentInBookingType } from "@afidium/ts-facade/model/priceTotalsContentInBookingType";
import { ActivatedRoute, Router } from "@angular/router";

import { SectorInBookingType } from "@afidium/ts-facade/model/sectorInBookingType";
import { DisplayType } from "libraries/component/menu-details-tarifications/menu-details-tarifications.component";
import {
    FareOptimisationNavigationService
} from "libraries/component/booking-information/components/booking-fare-optimisation-card/components/fare-optimisation-navigation/fare-optimisation-navigation.service";

class Wording {
    public optimisationTitle: string = Yii.t('wui-iqba-js', "Proposition d'optimisation :");
    public readonly labelReturn: string = Yii.t('wui-shared-js', 'Masquer le détail');
}

@Component({
    selector: 'tarifications-header',
    templateUrl: './tarifications-header.html',
    styleUrls: ['./tarifications-header.scss']
})
export class TarificationsHeaderComponent implements OnInit {

    @Input()
    public price: PriceInBookingType;

    @Input()
    public savingPrice: PriceTotalsContentInBookingType;

    @Input()
    public booking: BookingType;

    @Input()
    public bookingSyscode: string;

    @Input()
    public offerId: string;

    @Input()
    public costOrRetail: string;

    @Input()
    public showLink: boolean = true;

    @Input()
    public differences: DifferenceType[];

    @Input()
    public tarificationPrice?: PriceInBookingType;

    @Input()
    public useMaxHeight: boolean = false;

    @Input()
    public whenLastUpdated?: string;

    @Input()
    public showReturnBtn: boolean = false;

    @Output()
    public readonly onPriceSelect: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    public readonly onShowPricesDetailsChange: EventEmitter<DisplayType> = new EventEmitter();

    public readonly dateFormat: string = JSON.parse(wenji.ui.dateFormat).short;
    public pricesTotal: CurrencyUnitTotalType[] = [];
    public savingTotal: CurrencyUnitTotalType;
    public eRateType: typeof ERateType = ERateType;
    public priceTitle: string;
    public optimisationType: string;
    public wording: Wording = new Wording();
    public currentUrl: string = this.router.url;
    public isResultPage: boolean = this.currentUrl.includes('booking/search-result');
    public isFee: boolean = false;
    public isTransportation: boolean = false;
	public sectors: SectorInBookingType[];
    public showReturnButton: boolean = false;
    public display: DisplayType = DisplayType.pricesTable;

    public constructor(
        private readonly pricesTablesService: PricesTableService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly fareOptimisationNavigationService: FareOptimisationNavigationService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }

    public ngOnInit(): void {
        this.sectors = this.pricesTablesService.getSectorsByRate(this.price, this.booking, this.costOrRetail);
        if (this.differences?.length) {
            this.getOptimisationType();
            this.setSavingTotal(this.savingPrice);
        }
        this.pricesTotal = this.getPricesTotal(this.price[this.costOrRetail]);
        this.priceTitle = this.pricesTablesService.getRateTypeTitle(this.price, this.costOrRetail, this.booking.serviceArray);

        if(!this.offerId){
            if(this.price.cost.xRole === "Fee"){
                this.isFee = true;
            }
            if(this.price.cost.xRole === "Transportation"){
                this.isTransportation = true;
            }
        }
    }

    public getPricesTotal(price: PriceEnvelopeInBookingType): CurrencyUnitTotalType[] {
        return price?.total?.totalArray?.find((total: PriceItemType): boolean => !total.xReason).currencyArray;
    }

    public updateUrlWithOfferId(offerId: string): void {
        this.fareOptimisationNavigationService.updateUrlWithOfferId(offerId, this.router, this.activatedRoute);
    }

    public setSavingTotal(savingPrice: PriceTotalsContentInBookingType): void {
        const elementFound: CurrencyUnitTotalType[] = savingPrice?.totalArray?.find((total: PriceItemType): boolean => !total.xReason)?.currencyArray;
        if (elementFound?.length) {
            this.savingTotal = elementFound[0];
        }
    }

    public hideSelectedRate(): void {
        this.pricesTablesService.removeRateSelected();
        this.onShowPricesDetailsChange.emit(this.display);
        this.changeDetectorRef.detectChanges();
    }

    private getOptimisationType(): void {
        const actionFound: ActionInBookingType = this.price[this.costOrRetail].actionArray?.find(
            (action: ActionInBookingType): boolean => {
                return action.who.toLowerCase() === "fareoptimizer";
            });
        if (actionFound) {
            this.optimisationType = actionFound.code;
        }
    }
}
